export default __webpack_public_path__ + "static/media/hingo-screenshot-06.d87d93aa.png";